import { AssetDataUpload } from '@/asset/components/asset-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AssetDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Update asset data</DialogTitle>
      <DialogContent dividers>
        <AssetDataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
